const errorPath = "/error"

const redirectErrorPage = (siteurl: string) => `${siteurl}${errorPath}`

export default redirectErrorPage
